import { useTranslation } from "react-i18next";
import { useState } from "react";

import { Button } from "@/components/ui/button";
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";

interface Properties {
    open: boolean;
    setOpen: any,
    title: string;
    message: string;
    checkString?: string;
    /** Label of the OK button; defaults to the legacy "Delete" when a checkString is set. */
    okText?: string;
    /** Red danger styling for the OK button; defaults to true for checkString dialogs (legacy). */
    danger?: boolean;
    onOK?: any;
    onCancel?: any;
}

export default function ConfirmationDialog(properties: Properties) {
    const { t } = useTranslation();
    const [confirmString, setConfirmString] = useState() as any;
    const danger = properties.danger ?? !!properties.checkString;
    const okText = properties.okText || (properties.checkString ? 'Delete' : t('global.apply'));

    const close = (callback?: any) => {
        if (callback) {
            callback();
        }

        // reset so re-opening the dialog requires re-typing the check string
        setConfirmString(undefined);
        properties.setOpen(false);
    };

    return (
        <Dialog
            open={properties.open}
            onOpenChange={(open) => {
                if (!open) {
                    close(properties.onCancel);
                }
            }}
        >
            <DialogContent className="sm:max-w-[500px]">
                <DialogHeader>
                    <DialogTitle>{properties.title}</DialogTitle>
                    <DialogDescription>{properties.message}</DialogDescription>
                </DialogHeader>
                {properties.checkString
                    ?
                    <Input
                        value={confirmString ?? ""}
                        aria-label={properties.checkString}
                        onChange={(event) => setConfirmString(event.target.value)}
                    />
                    :
                    null}
                <DialogFooter>
                    <Button type="button" variant="outline" onClick={() => {
                        close(properties.onCancel);
                    }}>
                        {t('global.cancel')}
                    </Button>
                    <Button
                        type="button"
                        variant={danger ? "destructive" : "default"}
                        disabled={!!properties.checkString && properties.checkString !== confirmString}
                        onClick={() => {
                            close(properties.onOK);
                        }}
                    >
                        {okText}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
